import React from 'react';
import PropTypes from 'prop-types';
import styles from './StarRating.module.css';

const RATING_VALUES = [1, 2, 3, 4, 5];

const getStarClassName = (rating, value) => (
  `${rating <= value ? styles.filled : styles.empty}`
);

const StarRating = ({ value, onChange, disabled, readOnly, ariaLabel }) => {
  if (readOnly) {
    return (
      <div className={styles.rating} aria-label={`${value} out of 5`} role="img">
        {RATING_VALUES.map(rating => (
          <span
            aria-hidden="true"
            className={`${styles.readOnlyStar} ${getStarClassName(rating, value)}`}
            key={rating}
          >
            <i className="fa fa-star" />
          </span>
        ))}
      </div>
    );
  }

  return (
    <div className={styles.rating} role="radiogroup" aria-label={ariaLabel}>
      {RATING_VALUES.map(rating => (
        <button
          aria-checked={rating === value}
          aria-label={`${rating} star${rating === 1 ? '' : 's'}`}
          className={`${styles.starButton} ${getStarClassName(rating, value)}`}
          disabled={disabled}
          key={rating}
          onClick={() => onChange(rating)}
          role="radio"
          type="button"
        >
          <i aria-hidden="true" className="fa fa-star" />
        </button>
      ))}
    </div>
  );
};

StarRating.propTypes = {
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  value: PropTypes.number,
};

StarRating.defaultProps = {
  ariaLabel: 'Rating',
  disabled: false,
  onChange: () => {},
  readOnly: false,
  value: 0,
};

export default StarRating;
